/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};




//////////////////
// WEBPACK FOOTER
// ./~/isarray/index.js
// module id = 617
// module chunks = 60